// PayLater enums and interfaces
export enum LinkablePayLater {
    LAZYPAY = "PayLater_Lazypay",
    PAYTMPOSTPAID = "PayTM_PostPaid",
    SIMPL = "PayLater_Simpl",
    AMAZONPAYLATER = "AmazonPayLater",
}

export interface LinkPayLaterURIValue {
    creditLimit: string;
    isLinked: string;
    link: string;
    delink: string;
    validateOtp: string;
    resendOtp: string;
}

export type LinkPayLaterURI = {
    [key in LinkablePayLater]?: LinkPayLaterURIValue;
};

export interface ValidatePayLaterOtpParams {
    payLaterCode: LinkablePayLater;
    otp: string;
}

// Response interfaces
export interface Response<T = unknown> {
    statusCode: number;
    statusMessage?: string | null;
    data?: T | null;
    rawResponse?: unknown;
}

// PayLater DTO interfaces
export interface GetPayLaterResponse {
    linked: boolean;
    enabled?: boolean;
    disableMessage?: string;
}

export interface PayLaterResponse {
    linked: boolean;
    enabled?: boolean;
    disableMessage?: string;
}

export interface CreditLimitBusinessError {
    isBusinessError: true;
    statusMessage: string;
}
